import BatterySVG from 'assets/images/battery.svg?react';
import BusSVG from 'assets/images/bustop.svg?react';
import CarSVG from 'assets/images/cartop.svg?react';
import TruckSVG from 'assets/images/trucktop.svg?react';
import VanSVG from 'assets/images/vantop.svg?react';
import * as VehicleTypes from 'constants/VehicleTypes';
import { type ClassTypeEnum } from 'types/swagger';

export const getVehicleIcon = (vehicleType?: ClassTypeEnum) => {
  const { BUS, SEDAN, VAN, TRUCK } = VehicleTypes;
  switch (vehicleType) {
    case BUS:
      return <BusSVG />;
    case SEDAN:
      return <CarSVG />;
    case VAN:
      return <VanSVG />;
    case TRUCK:
      return <TruckSVG />;
    default:
      return <BatterySVG />;
  }
};

export const getClassByStatus = (status: string) => `is-${status.toLowerCase()}`;
